import React from 'react'

class EoiAttachmentRow extends React.Component {
  render() {
    return (
        <tr>
          <td className="text-center">
            <div className="spinner-icon js-attachment-spinner"></div>
          </td>
          <td>{ this.props.attachmentFilename }</td>
          <td> </td>
          <td> </td>
        </tr>
    );
  }
}

export default EoiAttachmentRow
